export const defaultGlobalSettings = {
  header: {
    settings: {
      firstPart: [],
      secondPart: [],
    },
  },
  footer: {
    settings: {
      column1: { title: "", items: [] },
      column2: { title: "", items: [] },
      supportBannerEnabled: false,
      mobileAppBannerEnabled: false,
    },
  },
  menu: {
    settings: {
      onlineCounterMin: 0,
      onlineCounterMax: 100,
      sportToggle: false,
      categories: [],
    },
  },
  mobileBar: {
    settings: {
      items: [],
    },
  },
  socials: {
    settings: {
      instagram: { enabled: false, href: "" },
      telegram: { enabled: false, href: "" },
      vk: { enabled: false, href: "" },
    },
  },
}
